// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

export const theme = {
  headerHeight: '65px',
  sizes: {},
  font: {
    sfProDisplay: 'SF Pro Display, sans-serif',
    sfProText: 'SF Pro Text, sans-serif',
  },
  colors: {
    primary: '#000',
    black: 'rgba(0, 0, 0, 1)',
    white: 'rgba(255, 255, 255, 1)',
    lightBlue: '#DBE7F2',
  },
  breakpoints: {
    xs: '480px',
    sm: '768px',
    md: '992px',
    mdlg: '1100px',
    lg: '1200px',
  },
};
